import React from "react";

const Footer = function (prop) {
  return (
    <footer
      className={
        (prop.class === undefined ? "" : prop.class) +
        ((prop.Reader_GeneralTermsFooter!=undefined && prop.Reader_GeneralTermsFooter!="")?" footer mt-auto py-2 bg-lighter rpd-footer":"")
      }
    >
      {(prop.Reader_GeneralTermsFooter!=undefined && prop.Reader_GeneralTermsFooter!="")&&
      <div className="container-fluid rpdFont">
        <p
          className="mb-0"
          style={{ textAlign: "center", fontSize: 0.78 + "rem" }}
        >
          <a
            className="footerLinks"
            href="https://rpost.com/legal-notices/terms-and-conditions/" target="_blank"
          >
            {prop.Reader_GeneralTermsFooter +((prop.Reader_GeneralTermsFooter!=undefined && prop.Reader_GeneralTermsFooter!="")?" & ":"")}  {prop.Reader_LegalNotices}
          </a>
          {((prop.Reader_ClickServiceLevelTerms!=undefined && prop.Reader_ClickServiceLevelTerms!="")?": ":"" )+ prop.Reader_ClickServiceLevelTerms+" "}
          <a
              className="footerLinks"
              href="https://rpost.com/legal-notices/legal-and-patent-notice/" target="_blank"
            >
              {prop.Reader_Patent}
            </a>
          {((prop.Reader_OtherService!=undefined && prop.Reader_OtherService!="")?", ":"" )+prop.Reader_OtherService}
        </p>
      </div>
}
    </footer>
  );
};
export default Footer;
